/**
 * @file automatically generated from MApp.Endpoints.AppEngineController
 */

import { MetadataClient } from '../metadataClient';
import { IGuidObject } from '../models';

export class AppEngineClient extends MetadataClient {

	public static getBrowserAppConfig(id: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getLegacyBrowserRuntime(id: string) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/legacyruntime/${encodeURIComponent(id)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getBrowserAppName(id: string) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}/name`, {
				cache: 'no-cache'
			})
		);
	}

	public static updateBrowserAppConfig(id: string, config: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(config),
				cache: 'no-cache'
			})
		);
	}

	public static getBrowserRuntimeConfig(id: string) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime/${encodeURIComponent(id)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getWarehousePrivateFile(name: string) {
		return MetadataClient.ajax<number[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/warehousefiles/private/${encodeURIComponent(name)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getWarehousePublicFile(name: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/warehousefiles/public/${encodeURIComponent(name)}`, {
				cache: 'no-cache'
			}),
			true
		);
	}

	public static saveBrowserRuntime(jsonConfig: string) {
		return MetadataClient.ajax<IGuidObject>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(jsonConfig),
				cache: 'no-cache'
			})
		);
	}

	public static cloneBrowserApp(id: string, newName: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browsermapps/clone/${encodeURIComponent(id)}?newName=${encodeURIComponent(newName)}`, {
				method: 'POST',
				cache: 'no-cache'
			})
		);
	}

	public static updateBrowserRuntime(id: string, jsonConfig: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(jsonConfig),
				cache: 'no-cache'
			})
		);
	}

	public static deleteBrowserRuntime(id: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime/${encodeURIComponent(id)}`, {
				method: 'DELETE',
				cache: 'no-cache'
			})
		);
	}

	public static getAttachment(id: string, runtimeName: string, attachmentName: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}/runtimes/${encodeURIComponent(runtimeName)}/attachments/${encodeURIComponent(attachmentName)}`, {
				cache: 'no-cache'
			}),
			true
		);
	}
}
